<div
  class="date-range-filter-menu-container"
  (click)="$event.stopPropagation()"
  >
  <!-- Select Date -->
  <section class="date-range-pickers-container">
    <div class="date-range-pickers">
      <div class="mat-calendar-container">
        <mat-calendar
          #fromCalendar
          class="date-range-calendar"
          [(selected)]="fromDate"
          (selectedChange)="onFromDateChange($event)"
          >
        </mat-calendar>
        <div class="date-values-containers">
          <span class="date-values-label">From</span>
          @if (fromDate) {
            <span class="date-values-value">{{
              formatDate(fromDate)
            }}</span>
          }
          @if (!fromDate) {
            <span class="date-values-value"
              >Pick A Date</span
              >
            }
          </div>
        </div>
        <div class="date-values-containers">
          <mat-calendar
            #toCalendar
            class="date-range-calendar"
            [(selected)]="toDate"
            (selectedChange)="onToDateChange($event)"
            >
          </mat-calendar>
          <div>
            <span class="date-values-label">To</span>
            @if (toDate) {
              <span class="date-values-value">{{
                formatDate(toDate)
              }}</span>
            }
            @if (!toDate) {
              <span class="date-values-value"
                >Pick A Date</span
                >
              }
            </div>
          </div>
        </div>
        <div class="date-range-apply">
          @if (datesMismatch) {
            <div class="date-range-mismatch">
              *<span>From</span> date needs to be <span>BEFORE</span> the
              <span>To</span> date
            </div>
          }
          <button
            type="button"
            class="date-range-apply-button"
            mat-raised-button
            color="primary"
            [disabled]="disableSelectButton()"
            (click)="applyDates()"
            >
            {{ applyButtonText }}
          </button>
        </div>
      </section>

      <!-- Options -->
      <section class="date-range-options">
        <div class="quick-options-label">
          <span>Quick Options</span>
          <div class="label-underline"></div>
        </div>

        <div class="quick-options-filter-buttons">
          @if (showLastSevenDaysPreset) {
            <button
              type="button"
              class="options-buttons filter-buttons"
              [ngClass]="{ 'active-buttons': lastSevenDaysActive }"
              color="primary"
              mat-stroked-button
              (click)="setLastSevenDaysDates()"
              >
              Last 7 Days
            </button>
          }
          @if (!hideDuePresets && !hideThisWeekPreset) {
            <button
              type="button"
              class="options-buttons filter-buttons"
              [ngClass]="{ 'active-buttons': thisWeekActive }"
              color="primary"
              mat-stroked-button
              (click)="setThisWeekDates()"
              >
              This Week
            </button>
          }
          @if (!hideDuePresets && !hideDueTodayPreset) {
            <button
              type="button"
              class="options-buttons filter-buttons"
              [ngClass]="{ 'active-buttons': dueTodayActive }"
              color="primary"
              mat-stroked-button
              (click)="setDueToday()"
              >
              Due Today
            </button>
          }
          @if (!hideDuePresets && !hideOverduePreset) {
            <button
              type="button"
              class="options-buttons filter-buttons"
              [ngClass]="{ 'active-buttons': overdueActive }"
              color="primary"
              mat-stroked-button
              (click)="getOverdueDates()"
              >
              Overdue {{ hideOverduePreset }}
            </button>
          }
        </div>

        <hr class="date-range-hr" />

        <div class="quick-options-reset-dates">
          <button
            type="button"
            class="options-buttons reset-dates-button"
            mat-stroked-button
            [disabled]="disableResetButton()"
            (click)="resetDates()"
            >
            Reset
          </button>
        </div>
      </section>
    </div>
